import { render, staticRenderFns } from "./product-category-import-modal.vue?vue&type=template&id=7b32a5ba&scoped=true&"
import script from "./product-category-import-modal.vue?vue&type=script&lang=js&"
export * from "./product-category-import-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-category-import-modal.vue?vue&type=style&index=0&id=7b32a5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b32a5ba",
  null
  
)

export default component.exports